import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const Careers = () => (
  <LegalPageLayout>
    <div className="legal-page">
      <div className="container legal-content text-center">
        <h2>Careers</h2>
        <p>This is a placeholder Careers page. Add your job openings and company culture here.</p>
      </div>
    </div>
  </LegalPageLayout>
);

export default Careers; 